import { BffError } from '../transport/relay'

/**
 * What a refusal from /account/groups/* says to the person, in words — the server answers with a
 * code (groups.py) and bffJson carries it as BffError.code.
 */
const SAID: Record<string, string> = {
  not_group_owner: 'Only the group’s owner can do that.',
  not_a_member: 'They are not in this group.',
  no_such_group: 'That group is not here any more.',
  no_such_invitation: 'That invitation is not here any more.',
  no_such_request: 'That request is not here any more.',
  already_member: 'Already in this group.',
  you_blocked_them: 'You blocked this account — unblock them first.',
  group_full: 'This group is full.',
  too_many_groups: 'That is too many groups for one account.',
  no_such_account: 'Nobody has signed in here with that email.',
  ambiguous_account: 'Two accounts use that email — pick the one you mean.',
  cannot_invite_self: 'You are in it already.',
  cannot_remove_self: 'To go, leave the group.',
  chat_unavailable: 'The chat is not reachable right now — try again in a moment.',
  rules_too_long: 'The rules can be at most 10,000 characters.',
  not_enough_sparks: 'You have no Sparks to spend. You earn them when a friend you invited joins, and when you beat a friend at a game.',
  no_post_limit: 'There is no posting limit for you here.',
  owner_only: 'Only the group’s owner posts in this group.',
  sparks_busy: 'Your Sparks are busy with another purchase — try again in a moment.',
}

export function groupErrorText(e: unknown): string {
  if (e instanceof BffError) {
    const said = SAID[e.code ?? '']
    if (said) return said
    const msg = e.body['message']
    return typeof msg === 'string' && msg ? msg : e.message
  }
  return e instanceof Error ? e.message : String(e)
}
